import Modal from '../shared/Modal';
import Btn from '../shared/Btn';

/**
 * @param {{ open: boolean, onClose: () => void, onConfirm: () => void }} props
 */
export default function DiscardEditsModal({ open, onClose, onConfirm }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Discard pending edits?"
      width={440}
      footer={<>
        <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
        <Btn variant="danger" onClick={onConfirm}>Discard</Btn>
      </>}
    >
      <p style={{ margin: 0 }}>
        Your unsaved edits will be discarded and the form will reload from the server.
      </p>
    </Modal>
  );
}
